import styled, { css } from "styled-components";
const statusStyle = {
  red: css`
    border: solid 0.5px rgba(237, 85, 101, 0.2);
    background-color: rgba(237, 85, 101, 0.1);
    color: #ed5565;
  `,
  green: css`
    border: solid 0.5px rgba(72, 207, 173, 0.2);
    background-color: rgba(72, 207, 173, 0.1);
    color: #48cfad;
  `,
  orange: css`
    color: #ffbf1d;
    border: solid 0.5px rgba(255, 191, 29, 0.2);
    background-color: rgba(255, 191, 29, 0.1);
  `,
};
export const TransactionMoreDeatils = styled.div`
  display: flex;
  flex-direction: column;
`;
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 6px;
  background-color: #ffffff;
  width: 100%;
  max-width: 600px;
  margin: auto;
  margin-bottom: 12px;
`;
export const TransactionMoreDeatilsItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 3px 10px;
`;
export const TransactionItemStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* border-radius: 12px;
  padding: 6px;
  background-color: #ffffff;
  width: 100%;
  max-width: 600px;
  margin: auto;
  margin-bottom: 12px; */

  & > div {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    flex-basis: 30%;
  }

  .tr_colored {
    padding: 5px 12px;
    border-radius: 10px;
    font-weight: bold;
    color: white;

    background-color: ${({ in_or_out }) => (in_or_out ? "#48cfad" : "#ed5565")};
  }

  .tr_date {
    border-radius: 12px;
    background-color: #f4f4f5;
    padding: 7px;
    flex-grow: 1;
    margin-left: 14px;
  }

  .tr_status {
    border-radius: 10px;
    /* background-color: red; */
    padding: 1.5px;

    ${({ status }) => {
      switch (status) {
        case 1:
          return statusStyle.green;

        case 2:
          return statusStyle.red;

        case 3:
          return statusStyle.orange;
        default:
          break;
      }
    }}
  }
`;
